'use client'

import { useI18n } from '@/locales/client'

export default function I18nTranslatorClient({ text }: { text: string }) {
  const t = useI18n()
  // @ts-expect-error text is not typesafe
  return <>{t(text)}</>
}
